import { AppRoutesNS } from 'src/app/app-routes.namespace'
import { environment } from 'src/environments/environment'

export function resolveMobileAppRedirect(): string {
  const mobileRedirect = environment.appRestrictions.mobileAppDefaultRedirect

  if (mobileRedirect && mobileRedirect !== AppRoutesNS.Root.ROOT) {
    return mobileRedirect
  }

  if (environment.moduleConfigs?.authModule?.afterLoginSuccessRedirect) {
    return environment.moduleConfigs.authModule.afterLoginSuccessRedirect
  }

  if (environment.unauthenticatedShoppingRedirect) {
    return environment.unauthenticatedShoppingRedirect
  }

  return AppRoutesNS.Upcoming.UPCOMING_BOOKINGS
}
